import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLocale } from "../../../../redux/action/localeAction";
import { Font } from "../../Fonts/Font";
import "./DropDown.scss";
import SelectCurrency from "react-select-currency";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
// import languages from "../../../../data/languages.json";
import cookies from "js-cookie";
import { userActions } from "../../../../redux/action";

const languages = [
  {
    code: "ar",
    name: "Arabic",
    flag: "\uD83C\uDDF8\uD83C\uDDE6",
  },
  {
    code: "bn",
    name: "Bangla",
    flag: "\uD83C\uDDE7\uD83C\uDDE9",
  },
  {
    code: "zh",
    name: "Chinese",
    flag: "\uD83C\uDDE8\uD83C\uDDF3",
  },
  {
    code: "zh-TW",
    name: "\u7E41\u9AD4\u4E2D\u6587",
    flag: "\uD83C\uDDF9\uD83C\uDDFC",
  },
  {
    code: "en",
    name: "English",
    flag: "\uD83C\uDDEC\uD83C\uDDE7",
  },
  {
    code: "fr",
    name: "French",
    flag: "\uD83C\uDDEB\uD83C\uDDF7",
  },
  {
    code: "de",
    name: "German",
    flag: "\uD83C\uDDE9\uD83C\uDDEA",
  },
  {
    code: "hi",
    name: "Hindi",
    flag: "\uD83C\uDDEE\uD83C\uDDF3",
  },
  {
    code: "it",
    name: "Italian",
    flag: "\uD83C\uDDEE\uD83C\uDDF9",
  },
  {
    code: "ja",
    name: "Japanese",
    flag: "\uD83C\uDDEF\uD83C\uDDF5",
  },
  {
    code: "pt",
    name: "Portuguese",
    flag: "\uD83C\uDDF5\uD83C\uDDF9",
  },
  {
    code: "ru",
    name: "Russian",
    flag: "\uD83C\uDDF7\uD83C\uDDFA",
  },
  {
    code: "es",
    name: "Spanish",
    flag: "\uD83C\uDDEA\uD83C\uDDF8",
  },
  {
    code: "th",
    name: "Thai",
    flag: "\uD83C\uDDF9\uD83C\uDDED",
  },
  {
    code: "uk",
    name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
    flag: "\uD83C\uDDFA\uD83C\uDDE6",
  },
  {
    code: "vi",
    name: "Vietnamese",
    flag: "\uD83C\uDDFB\uD83C\uDDF3",
  },
];
const onSelectLanguage = (languageCode) => {
};
export const SelectLanguage = ({ onHover, close, ...props }) => {
  const [selectLang, setSelectLang] = useState("English");
  const [selectCurrency, setSelectCurrency] = useState("USD");
  const [code, setCode] = useState("en");
  const locale = useSelector((el) => el?.locale.code);
  const lang = useRef(null);
  const currentLanguageCode = locale;
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const SubmitHandler = async () => {
    close();
    dispatch(
      setLocale({
        language: lang.current.value,
        currency: selectCurrency,
        code,
      })
    );
    i18next.changeLanguage(code);
    // Save preferred language to user account if logged in
    try {
      const token = localStorage.getItem("token");
      if (token) {
        import("../../../../helpers/api").then(({ default: axiosInstance }) => {
          axiosInstance.put("/user/profile", { preferred_language: code }).catch(() => {});
        });
      }
    } catch (e) { /* ignore */ }
  };
  const handleLangChnage = (language) => {
    setSelectLang(language);
    let cd = languages.find((el) => el.name === language);
    setCode(cd.code);
  };
  const onSelectedCurrency = (currencyAbbrev) => {
    setSelectCurrency(currencyAbbrev);
    dispatch(
      userActions.currencyConverter({
        toCurrency: currencyAbbrev,
        amount: 1000,
      })
    );
  };
  useEffect(() => {
    document.body.dir = currentLanguage.dir || "ltr";
  }, [currentLanguage, t]);
  return (
    <div
      className="modal header-modal"
      style={{ display: onHover ? "block" : "none" }}
      onMouseLeave={close}
    >
      <Font label={"Regional Settings"} size={18} weight={600} />
      <form>
        <div className="form-control">
          <label htmlFor="language">Language</label>
          <select
            name="country"
            id="country"
            className="p-2 mt-1"
            value={selectLang}
            ref={lang}
            onChange={(e) => handleLangChnage(e.currentTarget.value)}
          >
            {languages
              .filter((ele) => ele.name.length < 15)
              .map((el) => {
                return (
                  <option value={el.name} key={el.code}>
                    {el.name}
                  </option>
                );
              })}
          </select>
        </div>
        <div className="form-control">
          <label htmlFor="currency">Currency</label>
          <SelectCurrency
            value={selectCurrency}
            onChange={(e) => onSelectedCurrency(e.target.value)}
          />
        </div>
        <button type="button" onClick={SubmitHandler}>
          Save
        </button>
      </form>
    </div>
  );
};

SelectLanguage.defaultProps = {
  langOpt1: "English",
  langOpt2: "French",
  langOpt3: "Chinese",
  langOpt4: "Hindi",
  langOpt5: "Bangla",
  currOpt1: "USD",
  currOpt2: "UDT",
  currOpt3: "YEN",
  currOpt4: "INR",
};
